import { addDays, subDays } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Icon from 'components/atomic/Icon';
import DateInput from 'components/atomic/controls/DateInput';

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spaces.regular}px;
`;

const StyledInputContainer = styled.div`
  flex-grow: 1;

  .react-datepicker-wrapper {
    width: 100%;

    input {
      font-weight: 500;
      cursor: pointer;
    }
  }
`;

const StyledNavContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
  border-radius: 8px;
  background: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
  cursor: pointer;
`;

const DateFilter = ({ name, value = new Date(), onSelect }) => {
  const handleMoveBack = () => {
    onSelect && onSelect({ [name]: subDays(value, 1) });
  };

  const handleMoveForward = () => {
    onSelect && onSelect({ [name]: addDays(value, 1) });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    onSelect({ [name]: value });
  };

  return (
    <StyledContainer>
      <StyledInputContainer>
        <DateInput
          small
          textColor={theme.colors.gray.secondary}
          backgroundColor={hexToRGBA(theme.colors.gray.secondary, 0.08)}
          icon={<Icon alias={ICON_ALIASES.calendar} color={theme.colors.gray.secondary} />}
          name={name}
          value={value}
          dateFormat="MMMM dd, yyyy"
          onChange={handleChange}
        />
      </StyledInputContainer>
      <StyledNavContainer>
        <StyledIconContainer onClick={handleMoveBack}>
          <Icon alias={ICON_ALIASES.arrowLeft} color={theme.colors.gray.secondary} />
        </StyledIconContainer>
        <StyledIconContainer onClick={handleMoveForward}>
          <Icon alias={ICON_ALIASES.arrowRight} color={theme.colors.gray.secondary} />
        </StyledIconContainer>
      </StyledNavContainer>
    </StyledContainer>
  );
};

DateFilter.propTypes = {
  name: PropTypes.string,
  value: PropTypes.object,
  onSelect: PropTypes.func,
};

export default DateFilter;
